export const autoRun = [
    { name: 'Practice Name', key: 'practice Name' },
    { name: 'Status', key: 'status' },
]

export const topTenD = [
    { name: 'Remark', key: 'remark' },
    { name: 'Description', key: 'desc' },
    { name: 'Count', key: 'count' },
]
export const topTenN = [
    { name: 'Payer', key: 'payer' },
    { name: 'Count', key: 'count' },
]

export const dateRange = [
    { key: 'month_to_date', value: 'Month to Date' },
    { key: 'last_month', value: 'Last Month' },
    { key: 'year_to_date', value: 'Year to Date' },
]

export const passThroughData = [
    { month: 'Jan', rate: 97 }, 
    { month: 'Feb', rate: 85 }, 
    { month: 'Mar', rate: 75 }, 
    { month: 'Apr', rate: 55 }, 
    { month: 'May', rate: 45 }, 
    { month: 'Jun', rate: 65 }, 
    { month: 'July', rate: 95 }, 
    { month: 'Aug', rate: 85 }, 
    { month: 'Sep', rate: 76 }, 
    { month: 'Oct', rate: 83 }, 
    { month: 'Nov', rate: 95 },
    { month: 'Dec', rate: 65 },
];
